import {gettext} from 'topmeteo/utils/i18n';

import BaseToggle from '../BaseToggle';

const Title = gettext('More information');

const Toggle = props => (
    <BaseToggle
        {...props}
        className="mobile-only legend-toggle"
        panelType="legend"
        title={Title}
        icon="help"
    />
);

export default Toggle;
